import pairingErrors from '../../consts/device/pairingErrors';
import {setIsDeviceReady} from '../../state/ducks/iotDevice/actions';
import {setMwDeviceInternalId} from '../../state/ducks/mwDevice';
import {selectMwDeviceInternalId} from '../../state/selectors/mwDevice';
import {dispatch, getState} from '../../state/store';
import deviceTypesService from '../device/deviceTypesService';
import log from '../logger/log';
import marketConfigService from '../marketConfigService';
import pairingService from '../pairingService';
import yapConnectionService from '../yap/yapConnectionService';

const initIotService = async ({isReconnect, throwException = true, onError, initialDeviceType}) => {
    const {serial, type} = await yapConnectionService.initScpData({isReconnect, initialDeviceType});
    const isDeviceSupported = marketConfigService.isDeviceSupported(type);
    const isDeviceConnected = pairingService.isDeviceConnected();

    if (!serial || !isDeviceConnected) {
        if (throwException) {
            const msg = 'Device is not initialized';

            log.info(msg);
            throw new Error(msg);
        } else {
            pairingService.disconnectAndShowCriticalGuide();
        }
        return;
    }

    if (!isDeviceSupported) {
        const isDuoDevice = deviceTypesService.isSoyuz(type);
        const isDuoOrOriginalsDuoSupported = marketConfigService.isDuoOrOriginalsDuoSupported();

        // Duo and OriginalsDuo have the same type, so their support is determined at the stage of receiving assets
        if (!isDuoDevice || !isDuoOrOriginalsDuoSupported) {
            log.info(`User tried to connect device with type ${type} - it is not supported by the market`);

            if (onError) {
                onError(pairingErrors.ERROR_NOT_SUPPORTED_DEVICE);
            } else {
                throw new Error('Device is not supported');
            }
            return;
        }
    }

    const isWrongDevice = isWrongDeviceReconnected(isReconnect, serial);

    if (isWrongDevice) return;

    dispatch(setMwDeviceInternalId({deviceSerialNumber: serial, isIdentified: true}));
    dispatch(setIsDeviceReady());

    return true;
};

const isWrongDeviceReconnected = (isReconnect, serial) => {
    const deviceFromStateInternalId = selectMwDeviceInternalId(getState());

    const isSameDeviceInState = isReconnect ? deviceFromStateInternalId === serial : true;

    if (!isSameDeviceInState) {
        const msg = `There is device with another serialNumber in state, device in state: ${deviceFromStateInternalId}, serial number from response: ${serial}`;

        log.info(msg);

        pairingService.disconnectAndShowCriticalGuide();
        return true;
    }

    return false;
};

export default {
    initIotService,
};
